export const ACCESS_TOKEN = 'LOCAL@ACCESS_TOKEN'
export const TV_MODE_KEY = 'LOCAL@TV_MODE'
export const TV_CREDENTIALS_KEY = 'tvLoginCredentials'
export const TOKEN_REFRESH_EVENT = 'LOCAL@TOKEN_REFRESH'
export const LOGIN_USERNAME = 'LOCAL@LOGIN_USERNAME'
export const LOGIN_ROLEID = 'LOCAL@LOGIN_ROLEID'

export const SEARCH_FILTER_STORE = 'LOCAL@SEARCHFILTERSTORE'

export const THEME_STORE = 'LOCAL@THEMESTORE'
export const STORE_HEADER = 'LOCAL@STORE_HEADER'
export const STORE_HEADER_BUTTON = 'LOCAL@STORE_HEADER_BUTTON'
